import { render } from "./EcommerceSite.vue?vue&type=template&id=45b3c0c1&scoped=true"
import script from "./EcommerceSite.vue?vue&type=script&lang=js"
export * from "./EcommerceSite.vue?vue&type=script&lang=js"

import "./EcommerceSite.vue?vue&type=style&index=0&id=45b3c0c1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b3c0c1"]])

export default __exports__